import { appInfo } from '@/mocks/home';

export default function App() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1 w-full max-w-sm lg:max-w-none">
            <div className="relative w-full aspect-[3/4] max-w-xs mx-auto rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20colorful%20manga%20comic%20reader%20app%20interface%20with%20vibrant%20orange%20and%20warm%20red%20accent%20colors%20showing%20comic%20book%20page%20with%20action%20scene%20clean%20modern%20mobile%20UI%20design%20on%20device%20screen%20with%20simple%20elegant%20background&width=600&height=800&seq=app-mockup&orientation=portrait"
                alt="51漫画APP手机客户端界面展示"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>

          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">APP下载</h2>
            <h3 className="text-lg md:text-xl font-semibold text-foreground-900 mb-3">{appInfo.title}</h3>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              {appInfo.description}
            </p>

            <div className="grid grid-cols-2 gap-3 mb-6">
              {appInfo.features.map((feat) => (
                <div key={feat.label} className="flex items-center gap-3 p-3 bg-background-100 rounded-xl">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                    <i className={`${feat.icon} text-lg`}></i>
                  </div>
                  <div className="text-left">
                    <div className="text-sm font-semibold text-foreground-900">{feat.label}</div>
                    <div className="text-xs text-foreground-500">{feat.desc}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-full text-sm md:text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-line"></i>
                Android 下载
              </a>
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-800 font-medium rounded-full text-sm md:text-base hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer border border-background-200/70"
              >
                <i className="ri-apple-line"></i>
                iOS 下载
              </a>
            </div>
            <p className="text-xs text-foreground-500 mt-3">
              当前版本 {appInfo.version} · 安装包 {appInfo.size}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}